import { createFileRoute } from '@tanstack/react-router';
import { DeckPreview } from '../../../features/decks/deck-preview/deck-preview';

export const Route = createFileRoute('/_auth/decks/$deckId_/preview')({
  component: DeckPreviewRoute,
  parseParams: (params) => ({ deckId: parseInt(params.deckId, 10) }),
  stringifyParams: (params) => ({ deckId: params.deckId.toString() }),
});

function DeckPreviewRoute() {
  const { deckId } = Route.useParams();
  return (
    <div className="mx-auto max-w-4xl px-4 py-6 md:px-10 md:py-16">
      <DeckPreview deckId={deckId} />
    </div>
  );
}
